import { useSearch } from "@tanstack/react-router";
import { useMemo } from "react";

/**
 * Optimized hook to get the current task ID from URL search params.
 * Uses memoized selector to prevent unnecessary re-renders.
 */
export function useTaskId(): number | undefined {
    return useSearch({
        strict: false,
        select: useMemo(() => (s: any) => (s.task ? Number(s.task) : undefined), []),
    }) as number | undefined;
}
